// Importy komponentów widoków oraz layoutów (Blank/Default)
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ArchivalView from "../views/ArchivalView.vue";
import StatisticView from "../views/StatisticView";
import LoginView from "@/views/LoginView";
import ResetPasswordView from "@/views/ResetPasswordView";
import NotFoundView from "../views/NotFoundView.vue";
import BlankLayout from "@/layouts/BlankLayout";
import DefaultLayout from "@/layouts/DefaultLayout";
import { useAuthStore } from "@/stores/auth.store";
import { useUserStore } from "@/stores/user.store";
import VehicleDetailsView from "@/views/VehicleDetailsView";
import VmsView from "@/views/VmsView";
import BlackListView from "@/views/BlackListView";
import WhiteListView from "@/views/WhiteListView";
import ContactView from "@/views/ContactView";
import PreferenceView from "@/views/PreferenceView";
import { useCurrentStore } from "@/stores/current";
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService";
import UserManagementView from "@/views/UserManagementView";
import UserActivityView from "@/views/UserActivityView";
import RoleGroupManagementView from "@/views/RoleGroupManagementView";
import LocationStatusesView from "@/views/LocationStatusesView.vue";
import LocationLatestStatusView from "@/views/LocationLatestStatusView.vue";
import CalibrationView from "@/views/CalibrationView.vue";
import CalibrationDeviationView from "@/views/CalibrationDeviationView.vue";
import TicketsView from "@/views/TicketsView";
import ChangePasswordView from "@/views/ChangePasswordView.vue";
import EnterSmsCodeView from "@/views/EnterSmsCodeView.vue";
import Enter2faCodeView from "@/views/Enter2faCodeView.vue";
import Setup2faPhoneView from "@/views/Setup2faPhoneView.vue";
import PasswordExpiredView from "@/views/PasswordExpiredView.vue";
import { isSG } from "@/config/appVersion";
const TicketDetailsView = () => import('@/views/TicketDetailsView.vue');
const TicketEditView    = () => import('@/views/TicketEditView.vue');

const PWD_CHANGE_PATH = "/password-expired";
const PUBLIC_WHEN_PWD_EXPIRED = ["/login", PWD_CHANGE_PATH];

const isResetFlow = (path) =>
  path.startsWith("/reset-password") || path.startsWith("/set-password");

// Definicje wszystkich tras aplikacji
const routes = [
  {
    path: "/",
    name: "home",
    meta: { layout: DefaultLayout },
    component: HomeView,
  },
  {
    path: "/archival",
    name: "archival",
    meta: { layout: DefaultLayout },
    component: ArchivalView,
    access: "ArchiveMeasurements", // Ograniczenie dostępu przez uprawnienie
    children: [
      {
        path: "result",
        name: "result",
        meta: { layout: DefaultLayout, result: true },
      },
    ],
  },
  {
    path: "/stat",
    name: "statistics",
    meta: { layout: DefaultLayout },
    component: StatisticView,
    access: "Stat",
  },
  {
    path: "/vms",
    name: "VmsView",
    meta: { layout: DefaultLayout },
    component: VmsView,
    access: "Vms",
  },
  {
    path: "/user-management",
    name: "UserManagementView",
    // `meta.access` jest egzekwowane przez beforeEach (poniżej) — chroni przed
    // ręcznym wpisaniem URL-a przez usera bez wymaganego uprawnienia.
    meta: { layout: DefaultLayout, access: "UserManagement" },
    component: UserManagementView,
  },
  {
    path: "/user-activity",
    name: "UserActivityView",
    meta: { layout: DefaultLayout, access: "UserActivity" },
    component: UserActivityView,
  },
  {
    path: "/role-group-management",
    name: "RoleGroupManagementView",
    meta: { layout: DefaultLayout, access: "RoleManagement" },
    component: RoleGroupManagementView,
  },
  {
    path: "/calibration",
    name: "CalibrationView",
    meta: { layout: DefaultLayout },
    component: CalibrationView,
  },
  {
    path: "/calibration-deviation",
    name: "CalibrationDeviationView",
    meta: { layout: DefaultLayout },
    component: CalibrationDeviationView,
  },
  {
    path: "/tickets",
    name: "TicketsView",
    meta: { layout: DefaultLayout },
    component: TicketsView,
  },
  {
    path: "/tickets/:id",
    name: "ticket-details",
    meta: { layout: DefaultLayout },
    component: TicketDetailsView,
    props: route => ({ id: Number(route.params.id) }), // przekazanie ID jako prop
    access: "Tickets", // jeśli chcesz spiąć z uprawnieniem jak lista
  },
  {
    path: "/tickets/:id/edit",
    name: "ticket-edit",
    meta: { layout: DefaultLayout },
    component: TicketEditView,
    props: route => ({ id: Number(route.params.id) }), // przekazanie ID jako prop
    access: "Tickets",
  },  
  {
    path: "/location-statuses",
    name: "LocationStatusesView",
    meta: { layout: DefaultLayout },
    component: LocationStatusesView,
    access: "LocationStatuses",
  },
  {
    path: "/location-statuses/latest/:id",
    name: "LocationStatusLatestView",
    meta: { layout: DefaultLayout },
    component: LocationLatestStatusView,
    access: "LocationStatuses",
  },
  {
    path: "/black-list",
    name: "BlackListView",
    meta: { layout: DefaultLayout },
    component: BlackListView,
    access: "WantedList",
  },
  {
    path: "/white-list",
    name: "WhiteListView",
    meta: { layout: DefaultLayout },
    component: WhiteListView,
    access: "WantedList",
  },
  {
    path: "/contact",
    name: "ContactView",
    meta: { layout: DefaultLayout },
    component: ContactView,
    access: "WantedList",
  },
  {
    path: "/vehicle/:id/:location",
    name: "VehicleDetails",
    meta: { layout: DefaultLayout },
    component: VehicleDetailsView,
    access: "CurrentMeasurements",
  },
  {
    path: "/vehicleArch/:id/:location/:createdAt",
    name: "VehicleArchDetails",
    meta: { layout: DefaultLayout, timerVisible: false },
    component: VehicleDetailsView,
    access: "ArchiveMeasurements",
  },
  {
    path: "/preference",
    name: "preference",
    meta: { layout: DefaultLayout },
    component: PreferenceView,
    access: "SelfConfig",
  },
  {
    path: "/password-expired",
    name: "password-expired",
    meta: { layout: DefaultLayout },
    component: PasswordExpiredView,
    access: "SelfConfig",
  },
  // {
  //   path: "/users",
  //   name: "users",
  //   meta: { layout: DefaultLayout },
  //   component: UsersView,
  //   access: "UsersAdmin",
  // },
  { path: "/login", meta: { layout: BlankLayout }, component: LoginView },
  {
    // Drugi etap logowania — wpisanie 6-cyfrowego kodu z SMS-a. Sesja BE jest oznaczona
    // flagą `_2fa_pending` i blokuje wszystkie inne endpointy do czasu zweryfikowania kodu.
    // Stan po stronie frontu: `authStore.pendingTwoFactor`. Brak stanu = redirect na /login.
    path: "/login/2fa",
    meta: { layout: BlankLayout },
    component: Enter2faCodeView,
  },
  {
    // Ustawienie numeru telefonu admina przy pierwszym logowaniu (świeże konto). Po zapisaniu
    // numeru BE wysyła pierwszy kod 2FA i przerzuca na /login/2fa.
    path: "/login/2fa/setup-phone",
    meta: { layout: BlankLayout },
    component: Setup2faPhoneView,
  },
  {
    path: "/reset-password",
    meta: { layout: BlankLayout },
    component: ResetPasswordView,
    access: "PasswordChange",
  },
  {
    // Widok wpisania 6-cyfrowego kodu SMS. Numer telefonu — wcześniej wpisany w
    // ResetPasswordView — czyta ze stanu Pinii (auth.pendingSmsReset). Brak stanu =
    // odsyłka na początek flow. Numeru NIE ma w URL ani sessionStorage (PII).
    path: "/reset-password/code",
    meta: { layout: BlankLayout },
    component: EnterSmsCodeView,
    access: "PasswordChange",
  },
  {
    path: "/reset-password/reset",
    meta: { layout: BlankLayout },
    component: ChangePasswordView,
    access: "PasswordChange",
  },
  {
    // Legacy: linki wystawione przed migracją (z emailem w ścieżce). Email jest ignorowany,
    // identyfikacja usera idzie wyłącznie po tokenie z query string.
    path: "/reset-password/reset/:email",
    meta: { layout: BlankLayout },
    component: ChangePasswordView,
    access: "PasswordChange",
  },
  {
    path: "/:pathMatch(.*)*", // Fallback: nieznane trasy
    meta: { layout: BlankLayout },
    component: NotFoundView,
  },
];

// Tworzymy router Vue (history mode)
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Guard (przed każdą trasą)
// router.beforeEach(async (to) => {
//   // Definiujemy publiczne strony (nie wymagające logowania)
//   const publicPages = ["/login", "/reset-password", "/reset-password/reset"];
//   // Wszystko poza tym wymaga logowania
//   const authRequired = !publicPages.some(page => to.path.startsWith(page));
//   const authStore = useAuthStore();

//   if (to.path === '/login' && !authStore.returnUrl) {
//     authStore.returnUrl = isSG ? '/archival' : '/';
//   }

//   // Jeśli użytkownik NIE jest zalogowany i chce wejść na chronioną stronę – przekieruj na login
//   if (authRequired && !authStore.token) {
//     authStore.returnUrl = to.fullPath || authStore.returnUrl; // Zapisz, gdzie chciał wejść (żeby wrócić po zalogowaniu)
//     authStore.ping(true);              // Opcjonalnie: odśwież token/wymuś ping na backend
//     return "/login";
//   }
//   // Jeśli jest zalogowany i idzie na chronioną stronę – ping, by utrzymać sesję
//   else if (authRequired && authStore.token) {
//     authStore.ping(false);
//   }

//   if (authStore.token && to.path === '/login') {
//     // Jeśli jest zalogowany i idzie na login, przekieruj na stronę główną
//     return isSG ? '/archival' : '/';
//   }

//   if (authStore.token && to.path === '/' && isSG) {
//     return '/archival'; // Przekierowanie na stronę archiwalną dla SG
//   }

//   // Specjalna ścieżka do wylogowania (jeśli chcesz obsługiwać przez /logout)
//   if (to.path === "/logout") {
//     authStore.ping(true);
//     authStore.logout();
//   }
// });

router.beforeEach(async (to) => {
    const authStore = useAuthStore();

    // console.log('[beforeEach] to.fullPath =', to.fullPath, 'query =', to.query);

    // 👇 specjalna obsługa wejścia na /login z biletem
    if (to.path === "/login") {
        const search = window.location.search || "";
        const params = new URLSearchParams(search);
        const ticket = params.get("ticket");

        // console.log("[beforeEach] window.location.search =", search, "ticket =", ticket);

        if (ticket) {
            // zapamiętaj bilet zanim ktoś wyczyści query
            sessionStorage.setItem("desktopSsoTicket", ticket);
            // console.log("[beforeEach] zapisuję ticket do sessionStorage:", ticket);

            // i po prostu przepuść nawigację
            return true;
        }
    }

  // /reset-password i /set-password są w pełni publiczne — nie weryfikuj sesji ani
  // świeżości hasła, bo stary token w sessionStorage spowodowałby 401 → logout → /login.
  if (isResetFlow(to.path)) {
    return true;
  }

  // (opcjonalnie) jeżeli świeżo po zmianie hasła – przepuść ten jeden raz
  if (authStore.skipPwdFreshCheckOnce) {
    authStore.skipPwdFreshCheckOnce = false;
    return true;
  }

  // publiczne ścieżki dostępne bez tokena.
  // `/login/2fa*` jest tu, bo pierwszy etap logowania (hasło) nie zwraca tokena — jest tylko
  // sesja BE z flagą `_2fa_pending`. Token przyjdzie dopiero po `verify`.
  const publicRoots = ["/login", "/reset-password", "/reset-password/reset", PWD_CHANGE_PATH];
  const isPublic = publicRoots.some(p => to.path.startsWith(p));

  // domyślny returnUrl na /login
  if (to.path === '/login' && !authStore.returnUrl) {
    authStore.returnUrl = isSG ? '/archival' : '/';
  }

  // jeśli brak tokena i strona niepubliczna -> na login
  const needsAuth = !isPublic && !isResetFlow(to.path);
  if (needsAuth && !authStore.token) {
    authStore.returnUrl = to.fullPath || authStore.returnUrl;
    authStore.ping(true);
    return "/login";
  }

  // jeśli jest token — weryfikuj wymóg zmiany hasła
  if (authStore.token) {
    // 1) flaga z sesji lub store
    let mustChange =
      authStore.mustChangePassword ||
      sessionStorage.getItem("mustChangePwd") === "1";

    // 2) jeśli jeszcze nie ustawiona, sprawdź leniwie ważność hasła
    if (!mustChange && typeof authStore.ensurePasswordFreshness === "function") {
      try {
        const expired = await authStore.ensurePasswordFreshness();
        if (expired) {
          authStore._setMustChangePassword(true);
          mustChange = true;
        }
      } catch {
        // w razie błędu nie ustawiamy blokady
      }
    }

    // 3) BLOKADA: jeśli hasło wygasło — przepuszczaj TYLKO login/reset/password-expired
    const allowedWhenExpired =
      PUBLIC_WHEN_PWD_EXPIRED.includes(to.path) || isResetFlow(to.path);

    if (mustChange) {
      // nie odpalaj pingu dopóki hasło nieważne
      authStore.ping(true);

      // jeżeli user próbuje wejść gdziekolwiek indziej — na /password-expired
      if (!allowedWhenExpired) {
        return { path: PWD_CHANGE_PATH, replace: true };
      }
    } else {
      // hasło OK — utrzymuj sesję
      if (needsAuth) {
        authStore.ping(false);
      }
      // jeśli ktoś wejdzie na /password-expired bez potrzeby — przenieś na landing
      // (zależny od ról; dla SG-usera bez Archive idzie np. na /user-management).
      if (to.path === PWD_CHANGE_PATH) {
        const userStore = useUserStore();
        if (!userStore.currentUser) {
          try { await userStore.self(); } catch { /* ignoruj */ }
        }
        return userStore.landingPath();
      }
    }

    // drobne: zalogowany idzie na /login -> przenieś na landing (zależny od ról).
    if (to.path === "/login") {
      const userStore = useUserStore();
      if (!userStore.currentUser) {
        try { await userStore.self(); } catch { /* ignoruj */ }
      }
      return userStore.landingPath();
    }

    // specjalny /logout (jeśli chcesz obsługiwać)
    if (to.path === "/logout") {
      authStore.ping(true);
      authStore.logout();
    }
  }

  // SG ukrywa widok "/" (Current Measurements). Domyślnie kierujemy zalogowanego
  // SG-usera na /archival, ale jeśli nie ma do tego uprawnień (np. „admin abz"
  // z samym ROLE_19), `landingPath()` wybierze coś, do czego ma dostęp.
  if (authStore.token && to.path === '/' && isSG) {
    const userStore = useUserStore();
    if (!userStore.currentUser) {
      try { await userStore.self(); } catch { /* ignoruj */ }
    }
    return userStore.landingPath();
  }

  // Egzekucja `meta.access` — blokuje ręczne wbicie URL-a do widoku, do którego
  // user nie ma uprawnień (np. ROLE_19-only wchodzący na /role-group-management).
  // Userstore wymaga załadowanego `currentUser` — `self()` ładuje go i jest idempotentne.
  if (authStore.token && to.meta?.access) {
    const userStore = useUserStore();
    if (!userStore.currentUser) {
      try { await userStore.self(); } catch { /* ignore — fallback poniżej */ }
    }
    if (!userStore.hasAccess(to.meta.access)) {
      return isSG ? '/archival' : '/';
    }
  }

  // pozwól nawigację
  return true;
});

// afterEach: po przejściu na stronę główną, zerujemy liczbę nowych pojazdów i licznik zapytań
router.afterEach((to) => {
  const currentStore = useCurrentStore();
  if (to.path === '/') {
    CurrentMeasurementsService.setNewCarsNumber(0);
    currentStore.resetQueryCount();
  }
});

export default router;
